function service(state = {
  result: '', saveServiceInvoiceResult: '', serviceReset: false, serviceInfo: null, serviceInvoice: '',
  serviceUsedParts: '', serviceAttachments: [], serviceCountReport: [], serviceDeadlineReport: [], staffTotalfunctions: '',
  staffReportList: [], usedPartsList: [], serialHistoryPopup: '', serialHistory: [],selectStaffPopup:'', agentList:[], repairBugList:[], 
  faultsByCustomer:[], customerFaultsPopStatus:'', serviceStatusList:[], signaturePopStaus:'', serviceReceipt:'', serviceTotalCost:''
}, action) {

  switch (action.type) {

    case "ADD_SERVICE":
      return {
        ...state,
        result: action.data
      };
    case "RESET_SERVICE":
      return {
        ...state,
        serviceReset: action.data
      }
    case "GET_SERVICE":
      return {
        ...state,
        serviceInfo: action.data
      }
    case "GET_SERVICE_INVOICE":
      return {
        ...state,
        serviceInvoice: action.data
      }
    case "GET_SERVICE_USEDPARTS":
      return {
        ...state,
        serviceUsedParts: action.data
      }
    case "GET_SERVICE_ATTACHMENTS":
      return {
        ...state,
        serviceAttachments: action.data
      }
    case "GET_RELATEDSTAFFS":
      return {
        ...state,
        relatedStaffs: action.data
      }
      case "GET_AGENT_LIST":
        return {
          ...state,
          agentList: action.data
        }      
    case "GET_SERVICE_COUNT":
      return {
        ...state,
        serviceCountReport: action.data
      }
    case "SERVICE_DEADLINE_REPORT":
      return {
        ...state,
        serviceDeadlineReport: action.data
      }
    case "STAFF_TOTAL_FUNCTION":
      return {
        ...state,
        staffTotalfunctions: action.data
      }
    case "GET_STAFF_REPORT":
      return {
        ...state,
        staffReportList: action.data
      }
    case "SEARCH_USED_PARTS":
      return {
        ...state,
        usedPartsList: action.data
      }
    case "SAVE_SERVICE_INVOICE":
      return {
        ...state,
        saveServiceInvoiceResult: action.data
      }
    case "SET_SERIALHISTORY_POPUP":
      return {
        ...state,
        serialHistoryPopup: action.data
      }
    case "GET_SERIAL_HISTORY":
      return {
        ...state,
        serialHistory: action.data

      }
      case "SET_SELECTSTAFF_POPUP":
        return{
          ...state,
          selectStaffPopup:action.data
        }
        case "GET_REPAIR_BUGS":
          return {
          ...state,
          repairBugList:action.data
        }
        case "LOAD_FAULTS_CUSTOMER":
          return {
            ...state,
             faultsByCustomer:action.data
          }
          case "SET_CUSTOMER_FAULTS":
            return{
              ...state,
              customerFaultsPopStatus:action.data
            }
            case "GET_SERVICE_STATUS":
              return{
                ...state,
                serviceStatusList:action.data
              }
              case "SIGNATURE_POP":
                return{
                  ...state,
                  signaturePopStaus:action.data
                }
                case "GET_SERVICE_RECEIPT":
                  return{
                    ...state,
                    serviceReceipt:action.data
                  }
                  case "GET_SERVICE_TOTALCOST":
                    return{
                      ...state,
                      serviceTotalCost:action.data
                    }                  
    default:
      return state;
  }
}

export default service;